import { NavStyle } from './shared.style';
import * as RadixPopover from '@radix-ui/react-popover';
import styled from 'styled-components';

export const TriggerButton = styled(RadixPopover.Trigger)`
  border-width: 0;
  background: transparent;
  ${NavStyle}
`;

export const Content = styled(RadixPopover.Content)`
  z-index: 1000;
  background-color: white;
  border-style: solid;
  border-width: 1px;
  border-color: #e0ebed;
  border-radius: 0.5rem;
  box-shadow: 10px 10px 3px 1px rgba(215, 229, 231, 0.95);
  overflow: hidden;
  max-width: 95vw;
`;

export const PopoverArrow = styled(RadixPopover.Arrow)`
  width: 25px;
  height: 12px;
  margin-top: -1px;
  fill: white;
  clip-path: inset(0 -10px -10px -10px);
  stroke: #e0ebed;
  stroke-width: 1px;

  polygon {
    stroke-dasharray: 0 28 25;
  }
`;
